export default {
  INVALID_BROWSER: 'INVALID_BROWSER',
  WEBGL_DISABLED: 'WEBGL_DISABLED',
  WEBGL_NOT_SUPPORTED: 'WEBGL_NOT_SUPPORTED',
};
